module.exports = __webpack_public_path__ + "static/logo-0fa110f32504f5713b507c7650aa4b57.svg";